export const PageHeader = ({ title, subtitle, icon: Icon, children }) => (
  <header className="min-h-16 shrink-0 px-4 md:px-8 py-3 flex flex-wrap items-center gap-3 border-b border-slate-200 bg-white">
    {Icon && (
      <div className="w-9 h-9 rounded-lg bg-slate-100 grid place-items-center text-slate-700">
        <Icon size={18} />
      </div>
    )}
    <div>
      <h1 className="text-lg font-bold tracking-tight text-slate-900 leading-tight">{title}</h1>
      {subtitle && <p className="text-xs text-slate-500 hidden sm:block">{subtitle}</p>}
    </div>
    <div className="ml-auto flex flex-wrap items-center gap-2">{children}</div>
  </header>
);
